import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { RenderSearchForm } from '../../component/formInput';
import InvoiceStatus from '../../component/InvoiceStatus';
import Pagination from '../../component/Pagination';
import { InvoicePageRole } from '../../component/UserPermission';
import VATStatus from '../../component/VATStatus';
import VATStatusSelect from '../../component/VATStatusSelect';

var numeral = require('numeral');
var _ = require('lodash');

function InvoiceRows(userProfile, invoice_data, role_path) {
    const inner_invoice_rows = _.map(invoice_data,(invoice, key) => {
      return (
        <tr key={key}>
          <td>
            <Link to={role_path + "/invoice/detail/"+invoice.id}>{invoice.code}</Link>
            <br/>
            {userProfile && InvoicePageRole.isShowAgencyInvoice(userProfile.role) && invoice.agency_invoice && <Link to={"../invoice/agency/detail/"+invoice.agency_invoice.id}>{invoice.agency_invoice.code}</Link>}
          </td>
          <td>
            <Link to={"#"}>{invoice.user.email}</Link>
            <br/>
            {invoice.user.agency && !invoice.user.agency.has_custom_brand && <small className="text-muted"> <strong>Đại lý:</strong> {invoice.user.agency.agency_admin.email}</small>}
            {invoice.user.agency && invoice.user.agency.has_custom_brand && <small className="text-muted"> <strong>Thương hiệu riêng:</strong> {invoice.user.agency.agency_admin.email}</small>}
            {!invoice.user.agency && <small className="text-muted"> <strong>Khách lẻ</strong> </small>}
          </td>	
          <td>
            {invoice.sale ? invoice.sale.email : "N/A"}
            <br/>
            <small>{invoice.sale && invoice.sale.full_name}</small>
          </td>	
          <td>
            {invoice.payment_type}
          </td>
          <td>
            {InvoiceStatus(invoice.invoice_status, invoice.payment_date)}
          </td>
          <td>
            {VATStatus(invoice.vat_status)}
          </td>
          {userProfile && InvoicePageRole.isShowInvoiceMoney(userProfile.role) && <td>
            {numeral(invoice.total).format('0,0')}
          </td>}
          <td>
            {invoice.created_date}
          </td>
          <td>
            <div className="icons-list">
              <div className="dropdown">
                <a href="#" className="list-icons-item" data-toggle="dropdown">
                  <i className="icon-menu9"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right">
                  <Link to={role_path + "/invoice/detail/"+invoice.id} className="dropdown-item">
                    <i className="icon-list-numbered"></i> Chi tiết
                  </Link>
                </div>
              </div>
            </div>
          </td>
        </tr>
      )
    })
  return inner_invoice_rows;
}

class VATBillRequestTable extends React.Component {
  constructor(props) {
    const {vat_status} = props.routeProps.match.params;
    super(props);
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        sort_by: "",
        sort_asc: false,
        search_field: "search",
        search_value: "",
        vat_status: vat_status
      }
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }
  
  listReload = (table_query) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/invoice/vat_request/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }

  onVATStatusSelect = (vat_status) => {
    const { history, role_path } = this.props;
    const table_query = {
      ...this.state.table_query,
      vat_status: vat_status
    };
    // listReload after setState
    this.listReload(table_query);
    history.push(role_path + "/invoice/vat_request/"+ vat_status)
  }

  onSearchSubmit = (values) => {
    const search_value = values.search ? values.search : "";
    const { history, role_path } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: search_value,
      current_page: 1,
      vat_status: "all"
    };
    history.push(role_path + "/invoice/vat_request/all?search=" + search_value);
    this.listReload(table_query);
  }

  clearDataFilter = () => {
    const { reset } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
    reset();
    this.listReload(table_query);
  }
  
  onKeyPess = (key_code) => {
    const { history, role_path } = this.props;
    if (key_code == "Escape") {
      history.push(role_path + "/invoice/vat_request/all")
      this.clearDataFilter();
    }
  }

  render() {
    const { handleSubmit, userProfile, role_path } = this.props;
    const {table_query, table_data, alert_label, invoice_static} = this.state;
    return(
      <React.Fragment> 
        <div className="page-header">
          <h4>
            <i className="icon-paragraph-justify2"></i>
            <span className="text-semibold"> Danh sách Yêu Cầu Xuất Hóa Đơn</span>
          </h4>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Mã đơn hàng - Email khách hàng"
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div style={{margin:10}} className="text-align-right">
                <VATStatusSelect vat_status_selected={table_query.vat_status} onVATStatusSelect={this.onVATStatusSelect}/>
              </div>
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th>Mã Đơn Hàng</th>
                      <th>Khách Hàng</th>
                      <th>Sale man</th>
                      <th>Phương Thức TT</th>
                      <th style={{width: "130px"}}>Trạng Thái</th>
                      <th style={{width: "130px"}}>Trạng Thái HĐ</th>
                      <th>Tổng Tiền</th>
                      <th>Ngày Đăng Ký</th>
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data.data && InvoiceRows(userProfile, table_data.data, role_path)}
                  </tbody>
                </table>
              </div>
            </div>
            {userProfile && InvoicePageRole.isShowInvoicePagination(userProfile.role) && <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  role_path: state.userProfile.role_path,
  userProfile: state.userProfile.data
});

const mapDispatch = (dispatch) => ({

});

const VATBillRequestTableWrapper = reduxForm({
  form: 'VATBillRequestTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(VATBillRequestTable);

export default connect(mapState, mapDispatch)(withRouter(VATBillRequestTableWrapper));